export const CUSTOM_THEME = {
  engage4: {
    logo: require('../assets/images/company_logo.svg'),
    welcome: require('../assets/images/welcome.png'),
  },
  vidatecdev: {
    logo: require('../assets/images/company_logo.svg'),
    welcome: require('../assets/images/welcome.png'),
    firebaseConfig: {
      dev: require(`../firebase/envs/dev/firebaseConfig`),
      uat: require('../firebase/envs/uat/firebaseConfig'),
      live: require(`../firebase/envs/live/firebaseConfig`)
    },
  },
  myark: {
    logo: require('../assets/images/company_logo.svg'),
    welcome: require('../assets/images/welcome.png'),
    firebaseConfig: {
      dev: require(`../firebase/envs/dev/firebaseConfig`),
      uat: require('../firebase/envs/uat/firebaseConfig'),
      live: require(`../firebase/envs/live/firebaseConfig`),
    },
  },
  mygeorge: {
    logo: require('../themes/mygeorge/assets/company_logo.svg'),
    welcome: require(`../themes/mygeorge/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  vidatec: {
    logo: require(`../themes/vidatec/assets/company_logo.svg`),
    welcome: require(`../themes/vidatec/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../themes/vidatec/firebase/dev/firebaseConfig`),
      uat: require(`../themes/vidatec/firebase/uat/firebaseConfig`),
      live: require(`../themes/vidatec/firebase/live/firebaseConfig`),
    },
  }, //no firebase project for united capital and uses engage4 firebase project
  uc: {
    logo: require(`../themes/uc/assets/company_logo.svg`),
    welcome: require(`../themes/uc/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  bluestonewales: {
    logo: require(`../themes/bluestonewales/assets/company_logo.svg`),
    welcome: require(`../themes/bluestonewales/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  bedfordshire: {
    logo: require('../assets/images/company_logo.svg'),
    welcome: require(`../themes/bedfordshire/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  stockport: {
    logo: require('../themes/stockport/assets/company_logo.svg'),
    welcome: require(`../themes/stockport/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  dbth: {
    logo: require('../themes/dbth/assets/company_logo.svg'),
    welcome: require(`../themes/dbth/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  rdash: {
    logo: require('../themes/rdash/assets/company_logo.svg'),
    welcome: require(`../themes/rdash/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  dch: {
    logo: require('../themes/dch/assets/company_logo.svg'),
    welcome: require(`../themes/dch/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  midcheshire: {
    logo: require('../themes/midcheshire/assets/company_logo.svg'),
    welcome: require(`../themes/midcheshire/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  nwas: {
    logo: require('../themes/nwas/assets/company_logo.svg'),
    welcome: require(`../themes/nwas/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  swas: {
    logo: require('../themes/swas/assets/company_logo.svg'),
    welcome: require(`../themes/swas/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  uhtees: {
    logo: require('../themes/uhtees/assets/company_logo.svg'),
    welcome: require(`../themes/uhtees/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  onecovstaff: {
    logo: require('../themes/onecovstaff/assets/company_logo.svg'),
    welcome: require(`../themes/onecovstaff/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  TeamCHFT: {
    logo: require('../themes/chft/assets/company_logo.svg'),
    welcome: require(`../themes/chft/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  MyICFT: {
    logo: require('../themes/myICFT/assets/company_logo.svg'),
    welcome: require(`../themes/myICFT/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  TeamCRH: {
    logo: require('../themes/crh/assets/company_logo.svg'),
    welcome: require(`../themes/crh/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  yas: {
    logo: require('../themes/yas/assets/company_logo.svg'),
    welcome: require(`../themes/yas/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  LUHFT: {
    logo: require('../themes/luhft/assets/company_logo.svg'),
    welcome: require(`../themes/luhft/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  ourbht: {
    logo: require('../themes/bht/assets/company_logo.svg'),
    welcome: require(`../themes/bht/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  teamHDFT: {
    logo: require('../themes/teamHDFT/assets/company_logo.svg'),
    welcome: require(`../themes/teamHDFT/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  ncic: {
    logo: require('../themes/ncic/assets/company_logo.svg'),
    welcome: require(`../themes/ncic/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  mynuh: {
    logo: require('../themes/mynuh/assets/company_logo.svg'),
    welcome: require(`../themes/mynuh/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  kgh: {
    logo: require('../themes/kgh/assets/company_logo.svg'),
    welcome: require(`../themes/kgh/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  ngh: {
    logo: require('../themes/ngh/assets/company_logo.svg'),
    welcome: require(`../themes/ngh/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  trft: {
    logo: require('../themes/trft/assets/company_logo.svg'),
    welcome: require(`../themes/trft/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  uhd: {
    logo: require('../themes/uhd/assets/company_logo.svg'),
    welcome: require(`../themes/uhd/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  thh: {
    logo: require('../themes/uhd/assets/company_logo.svg'),
    welcome: require(`../themes/uhd/assets/welcome.png`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
  swyft: {
    logo: require('../themes/swyft/assets/company_logo.svg'),
    welcome: require(`../themes/swyft/assets/welcome.jpg`),
    firebaseConfig: {
      dev: require(`../firebase/firebaseConfig`),
      uat: require(`../firebase/firebaseConfig`),
      live: require(`../firebase/firebaseConfig`),
    },
  },
};
